import { render, staticRenderFns } from "./TicketDivider.vue?vue&type=template&id=deca1b44"
import script from "./TicketDivider.vue?vue&type=script&lang=js"
export * from "./TicketDivider.vue?vue&type=script&lang=js"
import style0 from "./TicketDivider.vue?vue&type=style&index=0&id=deca1b44&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports